import './component.scss'
import 'PackWerkNurikaeSite/pages/company/review/partials/clamp_text/component'
import 'PackWerkNurikaeSite/pages/company/review/partials/star_rating/component'
import './images/yet.svg'
import './images/done.svg'

import { Application, Controller } from 'stimulus'

const maxSpTextLines = 4
const maxPcTextLines = 3

const app = Application.start()

// レビューカード展開/折りたたみ機能
app.register(
  'review-card-toggle',
  class extends Controller {
    static targets = ["showMoreButton", "reviewRating", "reviewerInfo", "closeButton"]

    connect() {
      // 初期状態を設定
      this.showCollapsedState()
      this.bodyTextElement = this.element.querySelector('.clamp-line__body-text')
      this.clampElement = this.element.querySelector('.clamp-line')
    }

    toggleExpand() {
      this.showExpandedState()
      // テキストの省略を解除
      if (this.bodyTextElement) {
        this.bodyTextElement.style.webkitLineClamp = 'none'
        this.bodyTextElement.style.lineClamp = 'none'
      }
    }

    toggleCollapse() {
      this.showCollapsedState()
      // テキストの省略を復元
      if (this.bodyTextElement && this.clampElement) {
        const device = this.clampElement.getAttribute('data-device')
        const maxLines = device === 'sp' ? maxSpTextLines : maxPcTextLines
        this.bodyTextElement.style.webkitLineClamp = maxLines
        this.bodyTextElement.style.lineClamp = maxLines
      }
    }

    showExpandedState() {
      // 「すべて見る」ボタンを非表示
      this.showMoreButtonTarget.classList.add('review-card__hidden')
      // review-ratingとreviewer-infoを表示
      this.reviewRatingTarget.classList.remove('review-card__hidden')
      this.reviewerInfoTarget.classList.remove('review-card__hidden')
      // 「閉じる」ボタンを表示
      this.closeButtonTarget.classList.remove('review-card__hidden')
    }

    showCollapsedState() {
      // 「すべて見る」ボタンを表示
      this.showMoreButtonTarget.classList.remove('review-card__hidden')
      // review-ratingとreviewer-infoを非表示
      this.reviewRatingTarget.classList.add('review-card__hidden')
      this.reviewerInfoTarget.classList.add('review-card__hidden')
      // 「閉じる」ボタンを非表示
      this.closeButtonTarget.classList.add('review-card__hidden')
    }
  }
)
